

import React from 'react'
import SummaryIcon from './SummaryIcon'
import { Button, withStyles, withTheme } from '@material-ui/core';
import { compose } from "recompose";

const styles = (theme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '&>div': {
      margin: 16
    }
  },
  resultText: {
    color: theme.TextColor ?? "#000000",
    opacity: 0.6
  }
});
const Summary = ({ classes, totalCorrectAnswers, totalQuestions, handleRetakeAssessement, theme }) => {
  return (
    <div className={classes.mainContainer}>
      <div id="iconContainer">
        <SummaryIcon color={theme.commonAppHeaderTabColor}/>
      </div>
      <div className={classes.resultText}>
        You answered {totalCorrectAnswers} of {totalQuestions} questions correctly.
      </div>
      <div>
        <Button variant="contained" color="primary" onClick={handleRetakeAssessement}>
          Retake Assessment
        </Button>
      </div>
    </div>
  );
};

export default compose(
  withStyles(styles),
  withTheme()
)(Summary);